var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66683 0.833374H20.3335C20.3621 0.833374 20.3906 0.83429 20.4188 0.836093C20.4386 0.837357 20.4583 0.839059 20.4778 0.841187C21.1439 0.913712 21.6668 1.48211 21.6668 2.16671V4.83337C21.6668 5.56671 21.0668 6.16671 20.3335 6.16671C19.6002 6.16671 19.0002 5.56671 19.0002 4.83337V3.50004H3.00016V4.83337C3.00016 5.56671 2.40016 6.16671 1.66683 6.16671C0.933496 6.16671 0.333496 5.56671 0.333496 4.83337V2.16671C0.333496 1.43337 0.933496 0.833374 1.66683 0.833374ZM5.66816 14.1667C5.2615 14.1667 4.86283 13.9827 4.60016 13.6334C4.1575 13.044 4.2775 12.208 4.86683 11.7667L10.2002 7.76671C10.6615 7.42004 11.2962 7.41071 11.7668 7.74271L17.1002 11.4947C17.7028 11.9187 17.8482 12.7507 17.4242 13.352C17.0002 13.9534 16.1695 14.1 15.5668 13.676L12.3297 11.3988C12.3322 11.4323 12.3335 11.466 12.3335 11.5V22.1667C12.3335 22.9027 11.7375 23.5 11.0002 23.5C10.2628 23.5 9.66683 22.9027 9.66683 22.1667V11.5003L6.46683 13.9C6.22683 14.08 5.94683 14.1667 5.66816 14.1667Z",
    fill: "#19262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/IconUpload.24d1a0624534578ec04ca4a23087b8a2.svg";
export { ForwardRef as ReactComponent };